// @flow
import React, { Children, type Node } from 'react';
import classnames from 'classnames';

import { BREAKPOINTS } from 'Components/utils/responsive/Responsive.constants';

type Props = {
  children: Node,
  className?: string,
  grid?: { [breakpointName: $Keys<typeof BREAKPOINTS>]: string },
  hasTopGutters?: boolean,
  hasLeftGutters?: boolean,
};

function getResponsiveClasses(grid) {
  return Object.keys(BREAKPOINTS)
    .map(key => {
      if (grid.hasOwnProperty(key)) {
        return ` ${BREAKPOINTS[key]}-GridRow--${grid[BREAKPOINTS[key]]}`; // fit, full, 1of2, 1of3
      }
    })
    .join('');
}

export function GridRow({
  children,
  className,
  grid = {},
  hasLeftGutters = true,
  hasTopGutters = true,
}: Props) {
  if (!Children.count(children)) return null;

  return (
    <div
      className={classnames(
        className,
        'flex flex-wrap',
        {
          'GridRow--leftGutters': hasLeftGutters,
          'GridRow--topGutters': hasTopGutters,
        },
        getResponsiveClasses(grid),
      )}
    >
      {children}
    </div>
  );
}
